export enum ResearchEntityRequestItemStatus {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
    Refused = 'REFUSED',
}
